export const environment = {
  apiUrl: 'https://api.azes.apps.hosting/v1',
  wsUrl: 'ws://192.168.2.205:8080',
};
